import { useQuery } from '@tanstack/react-query';
import { getQuotesV2SummaryStatsQuery } from 'Services/Query/QuotesV2';
import type {
  GetQuotesV2Body,
  QuoteV2SearchFilter
} from 'Services/Query/QuotesV2/Types';

interface UseQuotesAnalyticsParams {
  statusId?: string;
  accountId?: string;
  date?: string[];
}

export const useQuotesAnalytics = (params: UseQuotesAnalyticsParams = {}) => {
  const conditions: QuoteV2SearchFilter[] = [
    { field: 'type', operator: '$eq', value: 'quote' }
  ];

  if (params.statusId)
    conditions.push({
      field: 'statusId',
      operator: '$eq',
      value: params.statusId
    });
  if (params.accountId)
    conditions.push({
      field: 'account._id',
      operator: '$eq',
      value: params.accountId
    });
  if (params.date?.length === 2)
    conditions.push({
      field: 'createdAt',
      operator: '$between',
      value: params.date
    });

  const body: GetQuotesV2Body = {
    limit: 20,
    offset: 0,
    filters: { $and: conditions }
  };

  const { data, isLoading, error } = useQuery(
    getQuotesV2SummaryStatsQuery(body)
  );

  return {
    analytics: data,
    loading: isLoading,
    error
  };
};
